import dayjs from "dayjs";

export const getFormattedDayjsTime = (time: any) => {
  if (!time) return "";
  const timeFormatted = dayjs(time, "HH:mm:ss").format("h:mm A");
  if (timeFormatted === "Invalid date") return "";
  return timeFormatted;
};
